import { useCallback } from "react";

/** Returns a function that scrolls to the bottom of a scroll container. */
export const useScrollToBottom = (scrollContainerRef: React.RefObject<HTMLElement | null>) => {
  const scrollToBottom = useCallback(
    (behavior: ScrollBehavior = "instant") => {
      if (!scrollContainerRef.current) return;

      scrollContainerRef.current.scrollTo({
        top: scrollContainerRef.current.scrollHeight,
        behavior,
      });
    },
    [scrollContainerRef],
  );
  return scrollToBottom;
};
